import { handleActions } from 'redux-actions';
import { logoutSuccess } from 'ducks/auth/actions';
import initialState, { settingsInitial } from './states';
import {
  settingsRequest,
  settingsSuccess,
  settingsFailure,
  updateSettingsRequest,
  updateSettingsSuccess,
  updateSettingsFailure,
} from './actions';

const normalize = (payload) => ({
  ...settingsInitial,
  ...(payload || {}),
});

export default handleActions(
  {
    [settingsRequest](state) {
      return { ...state, loading: true };
    },
    [settingsSuccess](state, { payload }) {
      return { ...state, data: normalize(payload), loading: false, loaded: true };
    },
    [settingsFailure](state) {
      return { ...state, loading: false };
    },
    [updateSettingsRequest](state) {
      return { ...state, saving: true };
    },
    [updateSettingsSuccess](state) {
      return { ...state, saving: false };
    },
    [updateSettingsFailure](state) {
      return { ...state, saving: false };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
